import { BaseFilters } from '../../projetos/tipos'

export interface Pessoa {
  idPessoa?: number
  nome: string
  email: string
  telefone?: string
  observacao?: string
  cargoCodigo?: number
  cargoNome?: string
  ativo: boolean
  dataCadastro?: string
  dataUltimaAtualizacao?: string
  timeId?: number
  tipoContratacaoDescricao?: string
  tipoPremiacaoDescricao?: string
  valorHoraAtual?: number
}

export interface PessoaFormData {
  idPessoa?: number
  nome: string
  email: string
  telefone?: string
  observacao?: string
  cargoCodigo?: string
  ativo: boolean
  timeId?: string
}

export enum TipoParametroPessoa {
  Contratacao = 1,
  Premiacao = 2,
  ValorHora = 3,
}

export interface PessoaParametrizacao {
  id: number
  pessoaId: number
  tipoParametro: TipoParametroPessoa
  tipoContratacaoCodigo?: number
  tipoContratacaoDescricao?: string
  tipoPremiacaoCodigo?: number
  tipoPremiacaoDescricao?: string
  valorHora?: number
  dataInicioVigencia: string
  dataFimVigencia?: string
}

export interface CriarParametrizacaoPayload {
  tipoParametro: TipoParametroPessoa
  tipoContratacaoCodigo?: number
  tipoPremiacaoCodigo?: number
  valorHora?: number
  dataInicioVigencia: string
}

export interface TipoContratacao {
  codigo: number
  descricao: string
}

export interface TipoPremiacao {
  codigo: number
  descricao: string
}

export interface PessoaFilters extends BaseFilters {
  search?: string
  ativo?: 'todos' | 'sim' | 'nao'
  cargoCodigo?: string
  timeId?: string
}

export interface CargoDisponivel {
  codigo: number
  nome: string
  descricao?: string
}
